module.exports = require("/root/webpage/src/styles-provider-props")